import ManifestPage from "./ManifestPage";
export default ManifestPage;
